"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TraitBonuses = exports.PlayerTraits = void 0;
var PlayerTraits;
(function (PlayerTraits) {
    // new traits
    PlayerTraits["STAMINA"] = "STAMINA";
    PlayerTraits["DEFENSIVE_EXPERT"] = "DEFENSIVE_EXPERT";
    PlayerTraits["STAR"] = "STAR";
    PlayerTraits["IGNITE"] = "IGNITE";
    PlayerTraits["RECOVER"] = "RECOVER";
    PlayerTraits["ORGANISED"] = "ORGANISED";
    PlayerTraits["INSPIRE"] = "INSPIRE";
    PlayerTraits["UNDEAD"] = "UNDEAD";
    PlayerTraits["ICON"] = "ICON";
    PlayerTraits["FIRST_TOUCH"] = "FIRST_TOUCH";
    PlayerTraits["RELIABLE"] = "RELIABLE";
    PlayerTraits["SWEEPER"] = "SWEEPER";
    PlayerTraits["COVER"] = "COVER";
    PlayerTraits["LEGEND_OF_LEGENDS"] = "LEGEND_OF_LEGENDS";
    PlayerTraits["SUPER_SUB"] = "SUPER_SUB";
    PlayerTraits["PRESSING"] = "PRESSING";
    PlayerTraits["LONG_BALL"] = "LONG_BALL";
    PlayerTraits["SHORT_PASS"] = "SHORT_PASS";
    PlayerTraits["TARGET"] = "TARGET";
    PlayerTraits["GOAL_MACHINE"] = "GOAL_MACHINE";
    PlayerTraits["SOUL_SAP"] = "SOUL_SAP";
    PlayerTraits["HALF_SPACES"] = "HALF_SPACES";
    PlayerTraits["MAN_MARKING"] = "MAN_MARKING";
    PlayerTraits["SECURE_POSSESSION"] = "SECURE_POSSESSION";
    PlayerTraits["WISE"] = "WISE";
    //TRAITS to change
    PlayerTraits["PRESS_RESISTANT"] = "PRESS_RESISTANT";
    //TODO loses 4 levels
    PlayerTraits["GOAL_KEEPER"] = "GOAL_KEEPER";
    //TODO TIKI Taka +3 if received ball from tiki taka teammate
    PlayerTraits["TIKI_TAKA"] = "TIKI_TAKA";
    //TODO rename to lethal
    PlayerTraits["LETHAL"] = "LETHAL";
    //Traits to keep the same
    PlayerTraits["SHIELD"] = "SHIELD";
    PlayerTraits["PLAYMAKER"] = "PLAYMAKER";
    PlayerTraits["POWERFUL"] = "POWERFUL";
    PlayerTraits["RAPID"] = "RAPID";
    PlayerTraits["CHARGE"] = "CHARGE";
    PlayerTraits["LUCKY"] = "LUCKY";
    PlayerTraits["FLAIR"] = "FLAIR";
    PlayerTraits["MANS_BEST_FRIEND"] = "MANS_BEST_FRIEND";
    PlayerTraits["UNDERDOG"] = "UNDERDOG";
    PlayerTraits["DOMINANT"] = "DOMINANT";
    PlayerTraits["HERO"] = "HERO";
    PlayerTraits["DETERMINED"] = "DETERMINED";
    PlayerTraits["UNYIELDING"] = "UNYIELDING";
    PlayerTraits["VERSATILE"] = "VERSATILE";
    // On Hold
    // On hold until levelling up cards is implemented
    // ADAPTABLE = "ADAPTABLE", // 1/2 XP to level up
    // PRODIGY = "PRODIGY", // 1/4 XP to level up
    // I've put these two traits on hold for now as there's questions over how we'd represent this in the UI
    // BALL_RETENTION = "BALL_RETENTION", //Round is a draw if this player is in possession and loses the contest by less than 5.
    // SCRAPPY = "SCRAPPY", //Round is a draw if this player is defending and losess the contest by less than 5
    // This one is on, because although I really want an intelligent trait, I can't think how it could apply
    // INTELLIGENCE = "INTELLIGENCE", // Allows choosing an action after seeing what card the opponent chooses to defend with (Consider clarifying mechanics)
    // on hold
    // FINESSE_SHOT = "FINESSE_SHOT", //This player can elect to shoot a finesse shot that uses a fixed 13 instead of the D20 score.
})(PlayerTraits || (exports.PlayerTraits = PlayerTraits = {}));
// Ensure all active PlayerTraits have a corresponding entry here
exports.TraitBonuses = {
    // Value is now mandatory
    // New traits
    [PlayerTraits.STAMINA]: -2 /* BonusTypes.STAMINA_LOSS */,
    [PlayerTraits.DEFENSIVE_EXPERT]: 2 /* BonusTypes.FIFTY_FIFTY */,
    [PlayerTraits.STAR]: 2 /* BonusTypes.FIFTY_FIFTY */,
    [PlayerTraits.IGNITE]: 1,
    [PlayerTraits.RECOVER]: 0 /* BonusTypes.NO_BONUS */,
    [PlayerTraits.ORGANISED]: 1 /* BonusTypes.TEAM_MATE */,
    [PlayerTraits.INSPIRE]: 1 /* BonusTypes.TEAM_MATE */, // The value of the bonus applied to teammates
    [PlayerTraits.UNDEAD]: 0 /* BonusTypes.NO_BONUS */,
    [PlayerTraits.ICON]: 1 /* BonusTypes.TEAM_MATE */, // The value of the bonus applied to teammates
    [PlayerTraits.FIRST_TOUCH]: 2 /* BonusTypes.CONTROLLABLE_LOCATION_AND_OR_ACTION */,
    [PlayerTraits.RELIABLE]: 4, // The direct bonus value applied conditionally
    [PlayerTraits.SWEEPER]: 0 /* BonusTypes.NO_BONUS */,
    [PlayerTraits.COVER]: 0 /* BonusTypes.NO_BONUS */,
    [PlayerTraits.LEGEND_OF_LEGENDS]: 2 /* BonusTypes.CONTROLLABLE_LINEUP */,
    [PlayerTraits.LONG_BALL]: 0 /* BonusTypes.NO_BONUS */,
    [PlayerTraits.SHORT_PASS]: 4,
    [PlayerTraits.TARGET]: 0 /* BonusTypes.NO_BONUS */,
    [PlayerTraits.GOAL_MACHINE]: 2 /* BonusTypes.FIFTY_FIFTY */, // The +2 bonus when condition met
    [PlayerTraits.SOUL_SAP]: 0 /* BonusTypes.NO_BONUS */,
    [PlayerTraits.HALF_SPACES]: 2 /* BonusTypes.CONTROLLABLE_LOCATION_AND_OR_ACTION */,
    [PlayerTraits.MAN_MARKING]: 2 /* BonusTypes.CONTROLLABLE_LOCATION_AND_OR_ACTION */,
    [PlayerTraits.PRESSING]: 2 /* BonusTypes.CONTROLLABLE_LOCATION_AND_OR_ACTION */,
    [PlayerTraits.WISE]: 1 /* BonusTypes.TEAM_MATE */,
    // Traits to change (or confirm existing bonus logic)
    [PlayerTraits.SECURE_POSSESSION]: 2 /* BonusTypes.CONTROLLABLE_LOCATION_AND_OR_ACTION */, // +3 bonus
    [PlayerTraits.PRESS_RESISTANT]: 2 /* BonusTypes.CONTROLLABLE_LOCATION_AND_OR_ACTION */, // Assuming this type implies a +3 or specific handling
    [PlayerTraits.GOAL_KEEPER]: 0 /* BonusTypes.NO_BONUS */,
    [PlayerTraits.TIKI_TAKA]: 2 /* BonusTypes.CONTROLLABLE_LOCATION_AND_OR_ACTION */ + 1, // +3 bonus as per new description
    [PlayerTraits.LETHAL]: 2 /* BonusTypes.FIFTY_FIFTY */ * 2, //Only counts for 2nd of half their contests
    // Traits to keep the same (with corrections where necessary)
    [PlayerTraits.SHIELD]: 2 /* BonusTypes.CONTROLLABLE_LOCATION_AND_OR_ACTION */, // +2 bonus
    [PlayerTraits.PLAYMAKER]: 2 /* BonusTypes.CONTROLLABLE_LOCATION_AND_OR_ACTION */, // +2 bonus
    [PlayerTraits.POWERFUL]: 2 /* BonusTypes.CONTESTABLE */, // Bonus logic is complex, type implies specific handling
    [PlayerTraits.RAPID]: 2 /* BonusTypes.CONTESTABLE */, // Bonus logic is complex, type implies specific handling
    [PlayerTraits.CHARGE]: 2 /* BonusTypes.CONTROLLABLE_LOCATION_AND_OR_ACTION */, // +3 bonus
    [PlayerTraits.LUCKY]: 20, // +20 bonus
    [PlayerTraits.FLAIR]: 2 /* BonusTypes.FIFTY_FIFTY */, // +2 bonus (as per BonusTypes.FIFTY_FIFTY value and trait desc)
    [PlayerTraits.MANS_BEST_FRIEND]: 2 /* BonusTypes.CONTROLLABLE_LINEUP */, // +3 bonus
    [PlayerTraits.UNDERDOG]: 2 /* BonusTypes.CONTROLLABLE_LINEUP */, // +2 bonus (as per BonusTypes.CONTROLLABLE_LINEUP value and trait desc)
    [PlayerTraits.DOMINANT]: 2 /* BonusTypes.CONTROLLABLE_LINEUP */, // +2 bonus
    [PlayerTraits.HERO]: 2 /* BonusTypes.CONTROLLABLE_LINEUP */, // +2 bonus
    [PlayerTraits.DETERMINED]: 2 /* BonusTypes.FIFTY_FIFTY */, // +2 bonus
    [PlayerTraits.UNYIELDING]: 2 /* BonusTypes.FIFTY_FIFTY */, // +2 bonus
    [PlayerTraits.SUPER_SUB]: 2 /* BonusTypes.FIFTY_FIFTY */, // +2 bonus
    [PlayerTraits.VERSATILE]: 1,
};
